<script>

import {onMount} from "svelte";
import {UserData}  from "../../../../stores.js";

import {updtUser} from '../../../../api/User';

let userImg = null;
let fileInput = null;
let userData = null;
let updateUser = false;
let dataReady = false;
let user = null;

let userAuxObj = null;


onMount(() =>{

	user = localStorage.getItem('user');
	user = JSON.parse(user);

	if(user.picture){
		userImg = user.picture;
	}

	userData = [];
	userAuxObj = {};

	for(let i = 0 ; i < UserData.length ; i++ ){

			var auxArray = [];
			for (const [key, value] of Object.entries(UserData[i])) {

				if(user[key]){
					// alert(key);
					userAuxObj[key] = user[key];

				}
  				auxArray.push(value);


			}

			userData.push(auxArray);

		}

		userData = userData;

})

function editHandle(){

	updateUser = !updateUser;

	if(updateUser){

	}
	else{
		dataReady = false;
	}
}

function saveData(){

	var allInputsValid = 0;
		


		for (const [key, value] of Object.entries(userAuxObj)) {
		  	
		  	if(value == null){
		  		
		  		//alert user - field must be filled
		  		var el = document.getElementById(key);
		  		el.style.border = "1px solid red";
		  		el.placeholder = 'enter a value';

		  	}
		  	else{
		  		// add aditional checking for value type
		  		allInputsValid++;
		  	}
		}

		if(allInputsValid == Object.keys(userAuxObj).length){
			
			dataReady = true;
			
		}
}


async function submitData() {

		var finalData = user;

		for (const [key, value] of Object.entries(finalData)) {


			if(userAuxObj[key]){

				finalData[key] = userAuxObj[key]; 
			}
		}

		delete finalData.auth;
		delete finalData.id;
		
		finalData.Picture = userImg;
		console.log('finalData:',finalData);


		var res = await updtUser(finalData);

		if(res.status == 'valid'){

			alert('Updated User info successfully!');
			localStorage.setItem('user', JSON.stringify(res.user));
			updateUser = false;
			dataReady = false;
			window.location.reload();

		}
		else if(res.status == 'error'){
			alert('error updating company data');
		}

}


function onFileSelected(e){

  let image = e.target.files[0];
            let reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                 userImg = e.target.result;
                 // companyInfo.Picture = userImg;
            };

}




</script>


<div class="userInfoContainer">


	<div class="userDataContainer">


			<div class="topContainer ">

				<div class="goBackBtnContainer">
					

					{#if updateUser}
						<div class="dataHandleBtn cancelBtn activeBtn" on:click={() => editHandle()}>
							Cancel
						</div>
						
						

						{#if dataReady}
							<div class="dataHandleBtn inactiveBtn">
								Save
							</div>
							
							<div class="dataHandleBtn activeBtn" on:click={() => submitData()}>
								Submit
							</div>
						{:else}

							<div class="dataHandleBtn activeBtn" on:click={() => saveData()}>
								Save
							</div>

							<div class="dataHandleBtn inactiveBtn">
								Submit
							</div>
						{/if}
						


					{:else}
						<div class="dataHandleBtn activeBtn" on:click={() => editHandle()}>
							Edit
						</div>
						
						<div class="dataHandleBtn inactiveBtn">
							Save
						</div>

					
						<div class="dataHandleBtn inactiveBtn">
							Submit
						</div>
					{/if}
				</div>
				
			</div>

			<div class="formContainer">


				{#if updateUser}
					<div class="companyAddColumn">
					

						{#if userImg}
							<img class="avatar" src={userImg} on:click={()=>{fileInput.click();}} alt="d" />

							<input 
								style="display:none" 
								type="file" 
								accept=".jpg, .jpeg, .png" 
								on:change={(e)=>onFileSelected(e)} 
								bind:this={fileInput}
							>

						{:else}

							<div class="imgUpload" on:click={()=>{fileInput.click();}}>
								<i class="fa-solid fa-user-large"></i>
								<div class="imgTxt">Upload profile image</div>
							</div>
							
							<input 
								style="display:none" 
								type="file" 
								accept=".jpg, .jpeg, .png" 
								on:change={(e)=>onFileSelected(e)} 
								bind:this={fileInput}
							>


						{/if}

					</div>

					{#if userAuxObj != null && userData != null}
						{#each userData as col,index}
							<div class="companyAddColumn">
									{#each col as input}

										<label class="formLabel" for={input.key}>{input.label} </label>
										{#if input.type == 'text'}
											
											{#if input.disabled}
												<input bind:value={userAuxObj[input.key]} class="formInput" type="text" name={input.label} id={input.key} placeholder={input.placeholder} disabled>
											{:else}
												<input bind:value={userAuxObj[input.key]} class="formInput" type="text" name={input.label} id={input.key} placeholder={input.placeholder}>
											{/if}
											
										{:else}

										{/if}

									{/each}
							</div>
						{/each}
						
					{/if}


				{:else}
					<div class="companyAddColumn">
					
						{#if userImg}
							<img class="avatar" src={userImg} alt="d" />

							<input 
								style="display:none" 
								type="file" 
								accept=".jpg, .jpeg, .png" 
								on:change={(e)=>onFileSelected(e)} 
								bind:this={fileInput}
							>

						{:else}

							<div class="imgUpload">
								<i class="fa-solid fa-user-large"></i>
								<div class="imgTxt">Upload profile image</div>
								
							</div>
							
							<input 
								style="display:none" 
								type="file" 
								accept=".jpg, .jpeg, .png" 
								on:change={(e)=>onFileSelected(e)} 
								bind:this={fileInput}
							>


						{/if}
						

					</div>


					{#if userAuxObj != null && userData != null}
						{#each userData as col,index}
							<div class="companyAddColumn">
									{#each col as input}

										<label class="formLabel" for={input.key}>{input.label} </label>
										{#if input.type == 'text'}
											
											<input bind:value={userAuxObj[input.key]} class="formInput" type="text" name={input.label} id={input.key} placeholder={input.placeholder} disabled>
										{:else}

										{/if}

									{/each}
							</div>
						{/each}
						
					{/if}


				{/if}
			</div>				
			
	</div>


	
</div>



<style>


.userInfoContainer{
	width: 100%;
	height: 100%;
	/*background-color: orangered;*/
	display: flex;
	flex-direction: column;
	align-items: center;
}

.userDataContainer{
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	justify-content: flex-start;
}

.topContainer{
	width: 100%;
	height: 6%;
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: flex-end;
	border-radius: 5px;
	margin-top: 3%;
}

.formContainer{
	width: 100%;
	height: 70%;
	/*background-color: white;*/
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;
	margin-top: 5%;
}


.goBackBtnContainer{
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: row;
	align-items: flex-end;
	justify-content: flex-end;
	border-top-left-radius: 5px;
	border-top-right-radius: 5px;
	margin-top: 0.4%;
}

.dataHandleBtn:nth-child(2), .dataHandleBtn:nth-child(3){
	margin-left: 2%;
}

.dataHandleBtn{
	width: 10%;
	height: 100%;
	border: 1px white solid;
	display: flex;
	align-items: center;
	justify-content: center;
	color: var(--brand-accent);
	opacity: 0.8;
	border-radius: 3px;
	font-size: 0.9114583333333334vw;
	cursor: pointer;
	box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
	transform: translateY(-5px);
}

.dataHandleBtn:hover{
	
}

.cancelBtn{
	color: red;
}


.activeBtn:hover{
	box-shadow: inset -4px -4px 4px rgba(255, 255, 255, 0.2), 
       inset 4px 4px 4px rgba(70, 70, 70, 0.3);
	transform: translateY(0px);
}
.inactiveBtn{
	color: black;
	opacity: 0.5;
}

.companyAddColumn{
	width: 33.33333%;
	height: 100%;
	/*background-color: red;*/
	flex-direction: column;
	gap: 2%;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
}

.companyAddColumn:nth-child(1){
	margin-left: 2.5%;
	align-items: center;
}

.companyAddColumn:nth-child(2){
	align-items: flex-start;
}
.companyAddColumn:nth-child(3){
	align-items: flex-end;
}

.avatar{
	display:flex;
	width:auto;
	height:20.775623268698062vh;
	max-height:20.775623268698062vh;
}

.imgUpload{
	width:9.765625vw;
	height:20.775623268698062vh;
	border-radius: 5px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 2%;
	margin-top: 1%;
	text-align: center;
	text-align-last: center;
	box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
	transform: translateY(-5px);
}

.imgUpload:hover{
	box-shadow: inset -4px -4px 4px rgba(255, 255, 255, 0.2), 
       inset 4px 4px 4px rgba(70, 70, 70, 0.3);
	transform: translateY(0px);
}

.imgUpload > i {
	transform: scale(1.3);
}

.imgTxt{
	color:black;
	font-size: 1.0416666666666667vw;
	font-weight: 700;
}



.formLabel{
	width: 90%;
	height: 2.770083102493075vh;
	background-color: transparent;
	color: black;
	opacity: 0.8;
	font-size: 0.9114583333333334vw;
	font-weight: 700;
}

.formInput{
	width: 90%;
	height: 5.54016620498615vh;
	border: 1px solid white;
	border-radius: 3px;
	background-color: transparent;
	color: black;
	font-size: 0.9114583333333334vw;
	font-weight: 700;
	box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
	transform: translateY(-5px);

}






</style>